import { render, staticRenderFns } from "./CusChatView.vue?vue&type=template&id=12a95452&scoped=true&"
import script from "./CusChatView.vue?vue&type=script&lang=js&"
export * from "./CusChatView.vue?vue&type=script&lang=js&"
import style0 from "./CusChatView.vue?vue&type=style&index=0&id=12a95452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a95452",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12a95452')) {
      api.createRecord('12a95452', component.options)
    } else {
      api.reload('12a95452', component.options)
    }
    module.hot.accept("./CusChatView.vue?vue&type=template&id=12a95452&scoped=true&", function () {
      api.rerender('12a95452', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/components/CusChatView.vue"
export default component.exports